module.exports = __webpack_public_path__ + "img/finish.65976b1.png";